module.exports = __webpack_public_path__ + "img/light_6.666efff8.png";